import { useUpdateCompany } from "@/api/console/companies/useUpdateCompany";
import BottomBar from "@/components/BottomBar";
import { Button } from "@/components/ui/button";
import { handleFormErrors } from "@/lib/handleFormErrors";
import toast from "@/lib/toast";
import { CompanyUpdate } from "@/schema/console/companies/CompanyUpdate";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { mutate } from "swr";

interface CompanyFormActionButtonsProps {
  id: string;
}

const CompanyFormActionButtons = ({ id }: CompanyFormActionButtonsProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { handleSubmit, setError } = useFormContext<CompanyUpdate>();

  const { trigger: updateCompany, isMutating: isCompanyMutating } =
    useUpdateCompany(id, {
      onSuccess: (data) => {
        toast.success(data.message);
        mutate(`/console/companies/${id}`);
        navigate(`/console/companies/${id}`);
      },
      onError: (error) => {
        handleFormErrors(error.errors, setError);
      },
    });

  return (
    <BottomBar backLink="/console/companies">
      <Button
        isLoading={isCompanyMutating}
        onClick={handleSubmit((data) => {
          toast.loading(t("update-company-loading"));
          updateCompany(data);
        })}
      >
        {t("save")}
      </Button>
    </BottomBar>
  );
};

export default CompanyFormActionButtons;
